module.exports = __webpack_public_path__ + "static/media/video.9d58932b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/PrinceHotel/video.jpg
// module id = 248
// module chunks = 0